import { Theme } from '@emotion/react'
import { createTheme, Theme as MuiTheme } from '@mui/material/styles'

export const muiAbsaTheme: MuiTheme = createTheme({
  typography: {
    fontSize: 12,
    fontWeightMedium: 400,
    fontWeightBold: 700
  },
  spacing: [0, 4, 8, 12, 16, 24, 36],
  palette: {
    primary: {
      main: '#AE001F'
    }
  }
})

export const absaTheme: Theme = {
  colors: {
    primary: '#AE001F'
  },
  space: [0, 4, 8, 12, 16, 24, 36],
  //      ^  ^  ^  ^   ^   ^   ^
  //      0  1  2  3   4   5   6

  fontSizes: [9, 11, 13, 15],
  //         ^   ^   ^    ^
  //         0   1   2    3

  fontWeights: [400, 700]
  //         ^  ^   ^   ^
  //         0  1   2   3
}
